// extracted by mini-css-extract-plugin
export var cell = "_5c-4";
export var headerCell = "_5c-2";
export var rowHeader = "_5c-3";
export var table = "_5c-1";
export var tableContainer = "_5c-0";